import React from 'react'
import PrintView from '../../components/PrintView/PrintView'
import image from '../../assets/images/neluma-product.webp'

const Neluma = () => {
  return <PrintView
  title='Neluma'
  heading='Neluma'
  content='One of the famous leopards from Wilpattu National Park and one of my favorites. Really good picture for a big print.'
  printImage={image}
 />
}

export default Neluma